// src/data/projectsData.js
import projectPreview_1 from '../images/Project1Preview.png'

const projectsData = [
  {
    id: 1,
    title: 'BulletHell Template',
    description: 'Bullet Hell game template, with authentication and database using Firebase and many game mechanics.',
    image: projectPreview_1, 
    link: 'https://assetstore.unity.com/templates/',
    featured: true,
    category: 'assets',
  },
];

export default projectsData;
